import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import OptionCalculatorCharts from "./OptionCalculatorCharts";
import OptionCalculatorPositions from "./OptionCalculatorPositions";
import {Paper} from "@mui/material";

const OptionCalculator = () => {

    return (
        <Paper>
            <Grid2 container spacing={2}>
                <Grid2 xs={12}>
                    <OptionCalculatorPositions/>
                </Grid2>
                <Grid2 xs={12}>
                    <OptionCalculatorCharts/>
                </Grid2>
            </Grid2>
        </Paper>
    );
};

export default OptionCalculator;
